import { useEffect, useMemo, useState } from "react";
import Lenis from "lenis";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/300-italic.css";
import "@fontsource/montserrat/400-italic.css";
import "@fontsource/jetbrains-mono/400.css";
import "@/App.css";
import { T } from "./content";
import { LangCtx } from "./components/site/ctx";
import { Intro } from "./components/site/Intro";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Stats } from "./components/site/Stats";
import { About } from "./components/site/About";
import { Kaolin } from "./components/site/Kaolin";
import { Marquee } from "./components/site/Marquee";
import { Process } from "./components/site/Process";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { MobileBar } from "./components/site/MobileBar";

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("balgat_lang") || "tr");

  useEffect(() => {
    localStorage.setItem("balgat_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  const value = useMemo(() => ({ lang, setLang, t: T[lang] }), [lang]);

  return (
    <LangCtx.Provider value={value}>
      <div className="App min-h-screen bg-[#FBFAF7] text-stone-900">
        <Intro />
        <Nav />
        <main>
          <Hero />
          <Stats />
          <About />
          <Kaolin />
          <Marquee />
          <Process />
          <Contact />
        </main>
        <Footer />
        <MobileBar />
      </div>
    </LangCtx.Provider>
  );
}

export default App;
